<template>
  <a v-if="href" :href="href" :class="classes" v-bind="$attrs">
    <span :class="[{ 'flex flex-row gap-2': icon || iconClass}, iconPositionClass]">
      <span>
        <slot>{{ text }}</slot>
      </span>
      <component :is="icon" v-if="icon" class="size-5" aria-hidden="true" />
      <span v-else-if="iconClass" :class="[iconClass, 'size-5']" aria-hidden="true" />
    </span>
  </a>

  <router-link v-else-if="to" :to="to" :class="[classes, 'inline-block']" v-bind="$attrs">
    <span :class="[{ 'flex flex-row gap-2': icon || iconClass}, iconPositionClass]">
      <span>
        <slot>{{ text }}</slot>
      </span>
      <component :is="icon" v-if="icon" class="size-5" aria-hidden="true" />
      <span v-else-if="iconClass" :class="[iconClass, 'size-5']" aria-hidden="true" />
    </span>
  </router-link>

  <button v-else :class="classes" v-bind="$attrs">
    <span :class="[{ 'flex flex-row gap-2': icon || iconClass}, iconPositionClass]">
      <span>
        <slot>{{ text }}</slot>
      </span>
      <component :is="icon" v-if="icon" class="size-5" aria-hidden="true" />
      <span v-else-if="iconClass" :class="[iconClass, 'size-5']" aria-hidden="true" />
    </span>
  </button>
</template>

<script lang="ts" setup>
import { PropType, useAttrs } from 'vue'
import { RouteLocationRaw } from 'vue-router'

const props = defineProps({
  href: {
    type: String,
    default: ''
  },
  to: {
    type: Object as PropType<RouteLocationRaw>,
    default: null
  },
  text: {
    type: String,
    default: ''
  },
  iconClass: {
    type: String,
    default: ''
  },
  icon: {
    type: Object,
    default: null
  },
  iconPosition: {
    type: String as PropType<'left' | 'right'>,
    default: 'right',
  },
  variant: {
    type: String as PropType<'base' | 'primary' | 'secondary' | 'accent' | 'danger'>,
    default: 'base'
  }
})

const attrs = useAttrs()
const baseClass = `rounded-md font-semibold shadow-sm ${attrs.disabled ? 'opacity-80' : ''}`
const colorClass = {
  base: 'bg-white text-slate-950 ring-1 ring-inset ring-slate-300 hover:bg-slate-100',
  primary: 'bg-primary-600 text-white hover:bg-primary-500',
  secondary: 'bg-secondary text-slate-950 hover:bg-secondary/80',
  accent: 'bg-accent text-slate-950 hover:bg-accent/80',
  danger: 'bg-error text-white hover:bg-error/80'
}
const sizeClass = 'px-3 py-2 text-sm'
const iconPositionClass = props.iconPosition === 'left' ? 'flex-row-reverse ' : ''

const classes = [baseClass, colorClass[props.variant], sizeClass]
</script>
